import { Component, inject, Input } from '@angular/core';
import { AssetService } from '../../../../../services/asset.service';
import { QuickLinkSignFormData } from '../../../../../models/quick-link-sign-form-data';
import { ResponseStatus } from '../../../../../models/modalable';
import { ModalComponent } from '../../../../../models/modal-component';
import { SignFormComponent } from '../../../page/book-feature/page-quick-link/sign-form/sign-form.component';
import { ModalableEdusuite } from '../../../../../models/modalable-edusuite';
import { AssetPipe } from '../../../../../pipes/asset.pipe';
import { ApplicationStateService } from '../../../../../services/application-state.service';

@Component({
    selector: 'app-edu-suite-modal',
    templateUrl: './edu-suite-modal.component.html',
    styleUrls: ['./edu-suite-modal.component.scss'],
    standalone: true,
    imports: [
        SignFormComponent,
        AssetPipe
    ]
})
export class EduSuiteModalComponent extends ModalComponent {
    @Input() declare modalable: ModalableEdusuite;
    protected eResponseStatus = ResponseStatus;
    protected assetService = inject(AssetService);
    protected applicationStateService = inject(ApplicationStateService);
    formData: QuickLinkSignFormData;

    getId(): string {
        return this.modalable.getModalId();
    }
}
